import '../style.scss'

interface SingleSelectPopUpProps {
	label: string
	valueLabels: string[]
	currentValueIndex?: number
	onValueSelected?: (selectedValue: number) => void
}

function SingleSelectPopUp({label, valueLabels, currentValueIndex, onValueSelected}: SingleSelectPopUpProps) {

	const valueIndicatorClicked = (index: number) => {
		if (onValueSelected) {
			onValueSelected(index as number)
		}
	}

	return (
		<div className='select-pop-up-wrap'>
			<div className="select-pop-up-label">
				{label}
			</div>
			<div className='select-pop-up-value-label-wrap'>
				{valueLabels.map((value: string, index) => 
					<div className='select-pop-up-value-label' key={`selectValueLabel${index}`}>{value}</div>
				)}
			</div>
			<div className='select-pop-up-value-indicator-wrap'>
				{valueLabels.map((label, index) => 
					<div 
						className={`select-pop-up-value-indicator ${currentValueIndex === index ? 'selected' : ''}`}
						key={`select-value-indicator-${label}${index}`}
						onClick={() => valueIndicatorClicked(index)}
					/>
				)}
			</div>
		</div>
	)
}

export default SingleSelectPopUp